/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/**
 * @description Renders the Testimonial Card component
 * @param cardData.cardData
 * @param {Array} cardData
 * @returns {ReactElement} Testimonial Card component
 */
const TestimonialCard = ({ cardData }) => {
  return (
    <>
      {cardData?.map((data, i) => {
        return (
          <Box
            key={i}
            m={{ base: '15px 0', md: '0 10px' }}
            bgColor="#5E1518"
            padding="20px"
            color="#fff"
            borderRadius="12px"
            position="relative"
            flexGrow="1"
            flexBasis="0"
            minW="0"
          >
            <Box
              bgImage={`url('${data?.photo?.url}')`}
              display="block"
              width={data?.photo?.url != undefined ? '122px' : ''}
              height="150px"
              backgroundRepeat="no-repeat"
              position="absolute"
              left="0"
              top="0"
              borderRadius="12px 4px 130px 0px"
            />
            <Box
              ml={
                data?.photo?.url != undefined ? { base: '0', md: '120px' } : '0'
              }
              mt={
                data?.photo?.url != undefined ? { base: '140px', md: '0' } : '0'
              }
              textAlign="left"
            >
              <Text mb={{ base: '30px', md: '50px' }}>
                {data?.testimonialText}
              </Text>
              <Text
                fontFamily="FedraSansStd-book"
                mb="5px"
                mt="auto"
                fontWeight="bold"
              >
                {data?.userName}
              </Text>
              <Text color="#FFCB12" mb="10px" fontFamily="Fedra-Light">
                {data?.userDescription}
              </Text>
            </Box>
          </Box>
        );
      })}
    </>
  );
};

export default TestimonialCard;
